import { Heading } from '@react-email/components';

const headingTwo = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        return (
            <Heading as="h2" {...attributes} {...element.attributes}>
                {children}
            </Heading>
        );
    },
    PreviewElement: ({ attributes, children }) => {
        return (
            <Heading as="h2" {...attributes}>
                {children}
            </Heading>
        );
    },
};

export default headingTwo;
